export async function fileExists(url: string) {
  return fetch(url, { method: 'HEAD' })
    .then((response) => response.ok)
    .catch(() => false);
}
